<template>
  <a-card class="m-display-flex flex-column">
    <span slot="title" v-if="$route.name === 'changePurchasing' || mode==='Edit'">Edit Supplier</span>
    <span slot="title" v-else>Create New Supplier</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Selection Criteria" />
      <a-step title="Supporting Documents" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
        >Save</a-button>
        <a-button v-if="current>0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import Informasi from "./steps/Informasi.vue";
import KriteriaSeleksi from "./steps/KriteriaSeleksi.vue";
import DokumenPendukung from "./steps/DokumenPendukung.vue";
import axios from "axios";

export default {
  name: "Create",
  props: ["id",'dataFor'],
  components: {
    Informasi,
    KriteriaSeleksi,
    DokumenPendukung
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi"
        },
        {
          title: "KriteriaSeleksi",
          content: "KriteriaSeleksi"
        },
        {
          title: "Last",
          content: "DokumenPendukung"
        }
      ],
      mode: "Create",
      collectData: [],
      editData: [],
      postData: [],
      btnLoading: false
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    stepProps: function() {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          if (this.collectData.length > 0) {
            return {
              data: this.collectData,
              mode: this.mode
            };
          }
        } else if (this.steps[this.current].content === "KriteriaSeleksi") {
          if (this.collectData.length > 1) {
            return {
              data: this.collectData[1].kriteria,
              mode: this.mode
            };
          }
        } else {
          if (this.collectData.length > 2) {
            return {
              data: this.collectData[2],
              mode: this.mode
            };
          }
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          if (this.collectData.length > 0) {
            return {
              data: this.collectData[0].informasi,
              mode: this.mode
            };
          }
        } else if (this.steps[this.current].content === "KriteriaSeleksi") {
          if (this.collectData.length > 1) {
            return {
              data: this.collectData[1].kriteria,
              mode: this.mode
            };
          }
        } else {
          if (this.collectData.length > 2) {
            return {
              data: this.collectData[2].dokumen,
              mode: this.mode
            };
          }
        }
      }
    },
    stepRef: function() {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "KriteriaSeleksi") {
        return "refKriteriaSeleksi";
      } else {
        return "refDokumenPendukung";
      }
    }
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchSuplier();
    }
  },
  methods: {
    fetchSuplier() {
      axios({
        method: "get",
        url: this.$serviceUrl + "suplier/supplier_Detil",
        params: {
          id_supplier: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData = [
            {
              informasi: response.data.detail_supplier[1].informasi
            },
            {
              kriteria: response.data.detail_supplier[2].kriteriaseleksi
            },
            {
              dokumen: response.data.doc_supplier,
              keterangan:
                response.data.detail_supplier[3].dokumenpendukung.catatan
            },
            {
              dokumenpendukung:
                response.data.detail_supplier[3].dokumenpendukung
            }
          ];
        })
        .catch(err => {
          let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error",responses);
        });
    },
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "KriteriaSeleksi") {
        this.$refs.refKriteriaSeleksi.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refDokumenPendukung.handleRef();
    },
    submitForm() {
      this.postData = new FormData();

      if (this.mode === "Edit") {
        this.postData.append("id_supplier", this.id);
      }
      this.postData.append(
        "nama_supplier",
        this.collectData[0].informasi.nama_supplier
      );
      this.postData.append("alamat", this.collectData[0].informasi.alamat);
      this.postData.append(
        "contact_person",
        this.collectData[0].informasi.contact_person
      );
      this.postData.append(
        "email",
        this.collectData[0].informasi.email?this.collectData[0].informasi.email:""
      );
      this.postData.append(
        "jenis_produk",
        this.collectData[0].informasi.jenis_produk
      );
      this.postData.append(
        "no_rekening",
        this.collectData[0].informasi.no_rekening
      );
      this.postData.append("bank", this.collectData[0].informasi.bank);
      this.postData.append(
        "user_request",
        this.collectData[0].informasi.user_request
      );

      this.postData.append("approval_bod", this.collectData[0].informasi.bod);
      this.postData.append("user_pembuat", this.getAuth.username);
      this.postData.append("kategori", this.collectData[0].informasi.kategori);
      this.postData.append(
        "spesifikasi_produk",
        this.collectData[1].kriteria.spesifikasi_produk
      );
      this.postData.append(
        "sertifikat_qms",
        this.collectData[1].kriteria.sertifikat_qms
      );
      this.postData.append(
        "sertifikat_usaha",
        this.collectData[1].kriteria.sertifikat_usaha
      );
      this.postData.append(
        "analisis_resiko",
        this.collectData[1].kriteria.analisis_resiko
      );

      this.collectData[2].dokumen.forEach(dokumen => {
        this.postData.append("nama_document[]", dokumen.file);
        this.postData.append("fungsi_document[]", dokumen.fungsi_document);
      });

      this.collectData[2].existing.forEach(dokumen => {
        this.postData.append("existing_id[]", dokumen.id_dokumen);
      });

      this.postData.append("catatan", this.collectData[2].keterangan ? this.collectData[2].keterangan : "");

      this.postData.append("is_domestic", this.collectData[0].informasi.is_domestic ? this.collectData[0].informasi.is_domestic : "");
      this.postData.append("is_pkp", this.collectData[0].informasi.is_pkp ? this.collectData[0].informasi.is_pkp : "");
      this.postData.append("no_npwp", this.collectData[0].informasi.no_npwp ? this.collectData[0].informasi.no_npwp : "");
    },
    submit() {
      this.submitForm();
      this.btnLoading = true;
      let urlRest = "suplier";
      if (this.mode === "Create") {
        urlRest = "suplier";
      } else if (this.mode === "Edit") {
        urlRest = "suplier/edit_supplier";
      }

      if(this.dataFor === 'supplier'){
        urlRest = "suplier/ubah_supplier"
      }

      axios({
        method: "post",
        url: this.$serviceUrl + urlRest,
        processData: false,
        data: this.postData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$router.go(-1);
        })
        .catch(err => {
          this.btnLoading = false;
          console.log("error : " + err);
        });
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.collectData.length <= 0) {
          this.collectData.push(JSON.parse(JSON.stringify(value)));
        } else {
          this.collectData[0] = JSON.parse(JSON.stringify(value));
        }
        this.current++;
      } else if (this.steps[this.current].content === "KriteriaSeleksi") {
        if (this.collectData.length > 1) {
          this.collectData[1] = JSON.parse(JSON.stringify(value));
        } else {
          this.collectData.push(JSON.parse(JSON.stringify(value)));
        }
        this.current++;
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        if (this.collectData.length > 2) {
          this.collectData[2] = value;
        } else {
          this.collectData.push(value);
        }
        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        }else{
          this.confirmMessage("confirm-save");
        }
      }
    }
  },
  mounted() {
    Event.$on("purchasingData", this.valueFromChild);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("purchasingData", this.valueFromChild);
    Event.$off("confirmMessageReturn", this.submit);
  }
};
</script>

<style>
</style>